import { Component, HostBinding } from '@angular/core';
import { ReferenceConst } from '@core-constants/reference.const';

@Component({
  selector: 'app-akky-pro-panel',
  templateUrl: './akky-pro-panel.component.html',
  styleUrls: ['./akky-pro-panel.component.css'],
  host: {
    class: 'container my-3 my-sm-5 text-center'
  }
})
export class AkkyProPanelComponent
{
  @HostBinding('style.max-height') public get setMaxHeight(): string
  {
    return '554px';
  }

  public openWhatsApp(): void
  {
    window.open(ReferenceConst.WhatsAppUrl, '_blank');
  }
}
